export default "/images/vendor/flag-icon-css/flags/1x1/pw.svg?2ba81a95ae7bbc2ef182ba0fddd2721e";